// Migration applied when the user changes a training's aspect ratio.
// Box position percentages NEVER change. Box sizes are uniformly scaled so
// their visual aspect ratio is preserved. No clamping — overflow allowed.
//
// Plugin toolbar size lives at tb.structure.{width,height} (numbers) with
// separate tb.structure.{widthUnit,heightUnit} ("%", "px", "auto", etc.).
// Only entries whose BOTH widthUnit and heightUnit are "%" get rescaled;
// non-percent and mixed-unit entries are preserved verbatim.

const REF_W = 1000;

export function migrateBoxesForRatio(state, oldRatio, newRatio) {
  if (!isFinite(oldRatio) || oldRatio <= 0) return state;
  if (!isFinite(newRatio) || newRatio <= 0) return state;
  if (Math.abs(oldRatio - newRatio) < 1e-6) return state;

  const oldCanvasH = REF_W / oldRatio;
  const newCanvasH = REF_W / newRatio;

  const scaleX = 1;
  const scaleY = newCanvasH / oldCanvasH;
  const uniformScale = Math.min(scaleX, scaleY);

  // Positions never change — shallow-clone box objects to keep immutability.
  const newBoxesById = {};
  for (const id of Object.keys(state.boxesById || {})) {
    const box = state.boxesById[id];
    newBoxesById[id] = { ...box, position: { ...box.position } };
  }

  const newToolbars = {};
  for (const id of Object.keys(state.pluginToolbarsById || {})) {
    const tb = state.pluginToolbarsById[id];
    const struct = tb.structure || {};

    if (struct.widthUnit === "%" && struct.heightUnit === "%") {
      const oldW = typeof struct.width === "number" ? struct.width : parseFloat(struct.width);
      const oldH = typeof struct.height === "number" ? struct.height : parseFloat(struct.height);
      if (isFinite(oldW) && isFinite(oldH)) {
        const oldPxW = (oldW / 100) * REF_W;
        const oldPxH = (oldH / 100) * oldCanvasH;
        const newPxW = oldPxW * uniformScale;
        const newPxH = oldPxH * uniformScale;
        const newW = (newPxW / REF_W) * 100;
        const newH = (newPxH / newCanvasH) * 100;
        newToolbars[id] = { ...tb, structure: { ...struct, width: newW, height: newH } };
      } else {
        newToolbars[id] = { ...tb, structure: { ...struct } };
      }
    } else {
      newToolbars[id] = { ...tb, structure: { ...struct } };
    }
  }

  return {
    ...state,
    boxesById: newBoxesById,
    pluginToolbarsById: newToolbars,
  };
}
